<template>
	<svg id="Badge" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
		<path
			fill="#fe6464"
			d="M300,33.22V266.78A33.23,33.23,0,0,1,268.32,300l0,0H33.22A33.22,33.22,0,0,1,0,266.78V33.22A33.22,33.22,0,0,1,33.22,0H266.78A33.22,33.22,0,0,1,300,33.22Z"
		/>
		<path fill="#bb5191" d="M119.9,25.66l-48.65,57L0,80.29V33.22A33.22,33.22,0,0,1,33.22,0h81.72Z" />
		<path fill="#fea702" d="M134,300H33.22A33.22,33.22,0,0,1,0,266.78V224.52l61.74-23L126,240.07Z" />
		<polygon
			fill="#bb5191"
			points="279.96 281.35 268.32 299.97 268.3 300 239.46 300 228.58 279.55 242.21 257.75 267.9 258.66 279.96 281.35"
		/>
		<polygon fill="#fea702" points="300 36.5 300 79.38 186.17 114.49 212.3 0 260.66 0 300 36.5" />
	</svg>
</template>
